
import { Questionario } from './questionario';
import { Resposta } from './resposta';

export class QuestionarioRespostaVO {

  public questionario: Questionario;
  public resposta: Resposta;
  
}
